import React, { useEffect, useState, useRef } from 'react'
import { Outlet, Link } from "react-router-dom";
import TopHeader from '../TopHeader';
import Footer from '../Footer'
import { MenuContext, TitleContext, PathContext } from "../../Context";
import { useContext } from "react";
import PreviousNext from '../PreviousNext';

export default function ReactJSLayout() {

    const addspaceElement = useRef();
    const menuElement = useRef([]);
    const menu = useContext(MenuContext);
    const pathName = useContext(PathContext);
    const pathname = pathName.pathName;
    const title = useContext(TitleContext);

    const setPathName = (path) => {
        pathName.setPathName(path);
    }

    useEffect(() => {
        setPathName(window.location.pathname)
        if (menu.isMenu == true) menu.setMenuOpen(false)
        addspaceElement.current.scrollIntoView(true)
        const element = document.getElementsByClassName("activeMenu")[0];
        element && element.scrollIntoView({ block: "center" });
        title.setKeyWords("React.js, React tutorial, React guide, React documentation, React installation, React features, React benefits, React library, React framework, React web development, React applications, React advantages, React components, React hooks, React state management, React context API, React lifecycle methods, React props, React , React virtual DOM, React router, React forms, React events, React performance optimization");
        title.setPageDescription("Learn React.js, a powerful JavaScript library for building dynamic and responsive user interfaces. Explore tutorials, guides, and best practices for mastering React development.")
    }, [pathname])


    return (
        <>
            <TopHeader />
            <div className='container-fluid'>
                <div className='row' style={{background:'#ddd'}}>
                    <div ref={menuElement} className={menu.isMenu == true ? 'col-md-3 col-lg-2 menuColumnMobile menuColumn p-0' : ' menuColumn p-0'} >
                        <div className='d-flex align-items-center headerMenu headerMainMenu sticky-top mb-4' style={{ 'height': '150px' }}>
                            <div>
                                <h2>React Js Tutorial</h2>
                                <Link to="/quiz/react-js" className='rounded-corner btn btn-primary float-end'><small>Get Quiz</small></Link>
                            </div>
                        </div>
                        <nav>
                            <ul>
                                <li className={pathname == '/react-js/introduction' ? 'activeMenu' : ''}>
                                    <Link to="/react-js/introduction" onClick={() => setPathName('/react-js/introduction')}>Introduction</Link>
                                </li>
                                <li className={pathname == '/react-js/features' ? 'activeMenu' : ''}>
                                    <Link to="/react-js/features" onClick={() => setPathName('/react-js/features')}>Features</Link>
                                </li>
                                <li className={pathname == '/react-js/start-new-application' ? 'activeMenu' : ''}>
                                    <Link to="/react-js/start-new-application" onClick={() => setPathName('/react-js/start-new-application')}>Start A New Application </Link>
                                </li>
                                <li className={pathname == '/react-js/folder-architecture' ? 'activeMenu' : ''}>
                                    <Link to="/react-js/folder-architecture" onClick={() => setPathName('/react-js/folder-architecture')}>Folder architecture </Link>
                                </li>
                                <li className={pathname == '/react-js/render-html' ? 'activeMenu' : ''}>
                                    <Link to="/react-js/render-html" onClick={() => setPathName('/react-js/render-html')}>Render HTML </Link>
                                </li>
                                <li className={pathname == '/react-js/jsx' ? 'activeMenu' : ''}>
                                    <Link to="/react-js/jsx" onClick={() => setPathName('/react-js/jsx')}>JSX </Link>
                                </li>
                                <li className={pathname == '/react-js/components' ? 'activeMenu' : ''}>
                                    <Link to="/react-js/components" onClick={() => setPathName('/react-js/components')}>Components </Link>
                                </li>
                                <li className={pathname == '/react-js/props' ? 'activeMenu' : ''}>
                                    <Link to="/react-js/props" onClick={() => setPathName('/react-js/props')}>Props </Link>
                                </li>
                                <li className={pathname == '/react-js/events' ? 'activeMenu' : ''}>
                                    <Link to="/react-js/events" onClick={() => setPathName('/react-js/events')}>Events </Link>
                                </li>
                            </ul>
                        </nav>

                        <div className='headerMenu'>
                            React Js Hooks
                        </div>
                        <nav>
                            <ul>
                                <li className={pathname == '/react-js/hooks' ? 'activeMenu' : ''}>
                                    <Link to="/react-js/hooks" onClick={() => setPathName('/react-js/hooks')}>Introduction </Link>
                                </li>
                                <li className={pathname == '/react-js/hooks/usestate' ? 'activeMenu' : ''}>
                                    <Link to="/react-js/hooks/usestate" onClick={() => setPathName('/react-js/hooks/usestate')}>useState</Link>
                                </li>
                                <li className={pathname == '/react-js/hooks/useeffect' ? 'activeMenu' : ''}>
                                    <Link to="/react-js/hooks/useeffect" onClick={() => setPathName('/react-js/hooks/useeffect')}>useEffect</Link>
                                </li>
                                <li className={pathname == '/react-js/hooks/usecontext' ? 'activeMenu' : ''}>
                                    <Link to="/react-js/hooks/usecontext" onClick={() => setPathName('/react-js/hooks/usecontext')}>useContext</Link>
                                </li>
                                <li className={pathname == '/react-js/hooks/useref' ? 'activeMenu' : ''}>
                                    <Link to="/react-js/hooks/useref" onClick={() => setPathName('/react-js/hooks/useref')}>useRef</Link>
                                </li>
                                <li className={pathname == '/react-js/hooks/usereducer' ? 'activeMenu' : ''}>
                                    <Link to="/react-js/hooks/usereducer" onClick={() => setPathName('/react-js/hooks/usereducer')}>useReducer</Link>
                                </li>
                                <li className={pathname == '/react-js/hooks/usecallback' ? 'activeMenu' : ''}>
                                    <Link to="/react-js/hooks/usecallback" onClick={() => setPathName('/react-js/hooks/usecallback')}>useCallback</Link>
                                </li>
                                <li className={pathname == '/react-js/hooks/usememo' ? 'activeMenu' : ''}>
                                    <Link to="/react-js/hooks/usememo" onClick={() => setPathName('/react-js/hooks/usememo')}>useMemo</Link>
                                </li>
                                <li className={pathname == '/react-js/hooks/custom' ? 'activeMenu' : ''}>
                                    <Link to="/react-js/hooks/custom" onClick={() => setPathName('/react-js/hooks/custom')}>Custom Hook</Link>
                                </li>
                            </ul>
                        </nav>

                        <div className='headerMenu'>
                            React Forms
                        </div>
                        <nav>
                            <ul>
                                <li className={pathname == '/react-js/forms' ? 'activeMenu' : ''}>
                                    <Link to="/react-js/forms" onClick={() => setPathName('/react-js/forms')}>Introduction </Link>
                                </li>
                                <li className={pathname == '/react-js/handling-form-submission' ? 'activeMenu' : ''}>
                                    <Link to="/react-js/handling-form-submission" onClick={() => setPathName('/react-js/handling-form-submission')}>Handling Form Submission </Link>
                                </li>
                                <li className={pathname == '/react-js/managing-form-user-input' ? 'activeMenu' : ''}>
                                    <Link to="/react-js/managing-form-user-input" onClick={() => setPathName('/react-js/managing-form-user-input')}>Managing User Input  </Link>
                                </li>
                                <li className={pathname == '/react-js/validating-form-user-input' ? 'activeMenu' : ''}>
                                    <Link to="/react-js/validating-form-user-input" onClick={() => setPathName('/react-js/validating-form-user-input')}>Validating User Input  </Link>
                                </li>
                            </ul>
                        </nav>
                        <div className='headerMenu'>
                            React Router
                        </div>
                        <nav>
                            <ul>
                                <li className={pathname == '/react-js/router' ? 'activeMenu' : ''}>
                                    <Link to="/react-js/router" onClick={() => setPathName('/react-js/router')}>Introduction </Link>
                                </li>
                                <li className={pathname == '/react-js/defining-router' ? 'activeMenu' : ''}>
                                    <Link to="/react-js/defining-router" onClick={() => setPathName('/react-js/defining-router')}>Defining Routes </Link>
                                </li>
                                <li className={pathname == '/react-js/navigating-between-pages-with-links' ? 'activeMenu' : ''}>
                                    <Link to="/react-js/navigating-between-pages-with-links" onClick={() => setPathName('/react-js/navigating-between-pages-with-links')}>Navigating Through Link </Link>
                                </li>
                                <li className={pathname == '/react-js/layouts-nested-routes' ? 'activeMenu' : ''}>
                                    <Link to="/react-js/layouts-nested-routes" onClick={() => setPathName('/react-js/layouts-nested-routes')}>Layouts & Nested Routes </Link>
                                </li>
                                <li className={pathname == '/react-js/showing-error-page' ? 'activeMenu' : ''}>
                                    <Link to="/react-js/showing-error-page" onClick={() => setPathName('/react-js/showing-error-page')}>ErrorPage </Link>
                                </li>
                                <li className={pathname == '/react-js/navigation-link' ? 'activeMenu' : ''}>
                                    <Link to="/react-js/navigation-link" onClick={() => setPathName('/react-js/navigation-link')}>Navigation Link (NavLink) </Link>
                                </li>
                                <li className={pathname == '/react-js/navigate-to-page-dynamically' ? 'activeMenu' : ''}>
                                    <Link to="/react-js/navigate-to-page-dynamically" onClick={() => setPathName('/react-js/navigate-to-page-dynamically')}>Navigate Dynamically </Link>
                                </li>
                                <li className={pathname == '/react-js/defining-dynamic-routes' ? 'activeMenu' : ''}>
                                    <Link to="/react-js/defining-dynamic-routes" onClick={() => setPathName('/react-js/defining-dynamic-routes')}>Defining Dynamic Routes </Link>
                                </li>
                            </ul>
                        </nav>

                        <div className='headerMenu'>
                            React Http Requests
                        </div>
                        <nav>
                            <ul>
                                <li className={pathname == '/react-js/handling-http-request' ? 'activeMenu' : ''}>
                                    <Link to="/react-js/handling-http-request" onClick={() => setPathName('/react-js/handling-http-request')}>Introduction </Link>
                                </li>
                                {/* <li className={pathname == '/react-js/data-fetching-from-http-requests' ? 'activeMenu' : ''}>
                                    <Link to="/react-js/data-fetching-from-http-requests" onClick={() => setPathName('/react-js/data-fetching-from-http-requests')}>Data Fetching </Link>
                                </li>
                                <li className={pathname == '/react-js/sending-http-requests' ? 'activeMenu' : ''}>
                                    <Link to="/react-js/sending-http-requests" onClick={() => setPathName('/react-js/sending-http-requests')}>Sending HTTP Requests </Link>
                                </li> */}
                                <li className={pathname == '/react-js/handling-states' ? 'activeMenu' : ''}>
                                    <Link to="/react-js/handling-states" onClick={() => setPathName('/react-js/handling-states')}>Handling Loading States </Link>
                                </li>
                                <li className={pathname == '/react-js/handling-http-errors' ? 'activeMenu' : ''}>
                                    <Link to="/react-js/handling-http-errors" onClick={() => setPathName('/react-js/handling-http-errors')}>Handling HTTP Errors </Link>
                                </li>
                                <li className={pathname == '/react-js/handling-fetched-data' ? 'activeMenu' : ''}>
                                    <Link to="/react-js/handling-fetched-data" onClick={() => setPathName('/react-js/handling-fetched-data')}>Transforming Fetched Data </Link>
                                </li>
                            </ul>
                        </nav>

                        <div className='headerMenu'>
                            React Js Styling
                        </div>
                        <nav>
                            <ul>
                                <li className={pathname == '/react-js/styling' ? 'activeMenu' : ''}>
                                    <Link to="/react-js/styling" onClick={() => setPathName('/react-js/styling')}>Introduction </Link>
                                </li>
                                <li className={pathname == '/react-js/css-files' ? 'activeMenu' : ''}>
                                    <Link to="/react-js/css-files" onClick={() => setPathName('/react-js/css-files')}>Vanilla CSS </Link>
                                </li>
                                <li className={pathname == '/react-js/inline-styles' ? 'activeMenu' : ''}>
                                    <Link to="/react-js/inline-styles" onClick={() => setPathName('/react-js/inline-styles')}>Inline styles </Link>
                                </li>
                                <li className={pathname == '/react-js/css-modules' ? 'activeMenu' : ''}>
                                    <Link to="/react-js/css-modules" onClick={() => setPathName('/react-js/css-modules')}>CSS modules </Link>
                                </li>
                                <li className={pathname == '/react-js/styled-component' ? 'activeMenu' : ''}>
                                    <Link to="/react-js/styled-component" onClick={() => setPathName('/react-js/styled-component')}>Styled Components </Link>
                                </li>
                                <li className={pathname == '/react-js/tailwind-css' ? 'activeMenu' : ''}>
                                    <Link to="/react-js/tailwind-css" onClick={() => setPathName('/react-js/tailwind-css')}>Tailwind CSS </Link>
                                </li>
                            </ul>
                        </nav>
                        
                        <div className='headerMenu'>
                            React Js & Redux
                        </div>
                        <nav>
                            <ul>
                                <li className={pathname == '/react-js/redux' ? 'activeMenu' : ''}>
                                    <Link to="/react-js/redux" onClick={() => setPathName('/react-js/redux')}>Introduction </Link>
                                </li>
                                <li className={pathname == '/react-js/redux/data-flow' ? 'activeMenu' : ''}>
                                    <Link to="/react-js/redux/data-flow" onClick={() => setPathName('/react-js/redux/data-flow')}>Data Flow </Link>
                                </li>
                                <li className={pathname == '/react-js/redux/create-a-store' ? 'activeMenu' : ''}>
                                    <Link to="/react-js/redux/create-a-store" onClick={() => setPathName('/react-js/redux/create-a-store')}>Creating a Store </Link>
                                </li>
                                <li className={pathname == '/react-js/redux/dispatching-an-action' ? 'activeMenu' : ''}>
                                    <Link to="/react-js/redux/dispatching-an-action" onClick={() => setPathName('/react-js/redux/dispatching-an-action')}>Dispatching a Action </Link>
                                </li>
                                <li className={pathname == '/react-js/redux-vs-context-api' ? 'activeMenu' : ''}>
                                    <Link to="/react-js/redux-vs-context-api" onClick={() => setPathName('/react-js/redux-vs-context-api')}>Redux vs Context API </Link>
                                </li>
                            </ul>
                        </nav>

                    </div>
                    <div className='col-12 middlePart'>
                        
                        <div className='headerAdSpace' ref={addspaceElement}>
                            <img className='img-fluid' src='https://aspirantshome.com/slide1.png' />
                        </div>
                        <div className='contentPart row sticky-top'>
                            <div className='col-12 col-md-12 mb-4 contentSection'>
                                <div className='container'>
                                    <div className='contentPage'>
                                        {
                                            pathName.urls ? <PreviousNext urls={ pathName.urls } name={pathName.backname} /> : <></>
                                        }
                                            <Outlet />
                                        {
                                            pathName.urls ? <PreviousNext urls={ pathName.urls } /> : <></>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className='footerAdSpace'>
                                <img className='img-fluid' src='https://aspirantshome.com/slide4.png' />
                            </div>
                        </div>

                        
                    </div>
                    <div className='col-12  rightPart'>
                        <img className='img-fluid' src='https://aspirantshome.com/slide2.png' />
                        <img className='mt-5 img-fluid' src='https://aspirantshome.com/slide3.png' />
                    </div>
                </div>
                <div className='row'>
                    <div className='col-12'>
                        <div className='container-fluid footerPart'>
                            <Footer />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
